module.exports = __webpack_public_path__ + "img/Western Sahara.ae65d577.svg";